import * as React from 'react'
import { Image, StyleSheet, TouchableOpacity, Dimensions, Vibration, View , Platform} from 'react-native'
import { Audio, AVPlaybackStatus } from 'expo-av'

import PlayerControls from './PlayerControls'
import Screen from '../../components/Screen'
import { Text } from '../../components/Themed'
import { useAppSelector, useMeditation } from '../../hooks'
import NotFoundScreen from '../NotFoundScreen'
import { HomeParamList, MainStackParamList } from '../../types'
import { CompositeNavigationProp, RouteProp, useNavigationContainerRef } from '@react-navigation/native'
import { useMsToTime, useAppDispatch } from '../../hooks'
import { completed, updateFavourite } from '../../redux/meditationSlice'
import { LoadingScreen } from '../../components'
import { useCallback } from 'react'
import { StackNavigationProp } from '@react-navigation/stack'
import { selectFavourites, selectFilePaths } from '../../redux/selectors'
import FavouriteButton from '../../components/FavouriteButton'
import { Meditation } from '../../data/meditations'

type PlayRouteProp = RouteProp<HomeParamList, 'DildScreen'>

type PlayNavProp = CompositeNavigationProp<
  StackNavigationProp<HomeParamList, 'DildScreen'>,
  StackNavigationProp<MainStackParamList>
>
interface Props {
  navigation: PlayNavProp
  route: PlayRouteProp
}
export default function DildScreen({ route, navigation }: Props) {
  const { id } = route.params
  const meditation = useMeditation(id)
  const favourites = useAppSelector(selectFavourites)
  const [isLoadingAudio, setIsLoadingAudio] = React.useState(true)
  const [isPlaying, setIsPlaying] = React.useState(false)
  const [isRunning, setIsRunning] = React.useState(false)
  const [remainingSeconds, setRemainingSeconds] = React.useState(60)
  const [sound, setSound] = React.useState<Audio.Sound>()
  const [positionMillis, setPositionMillis] = React.useState(0)
  const [durationMills, setDurationMills] = React.useState(0)
  const durationTime = useMsToTime(durationMills)
  const positionTime = useMsToTime(positionMillis)
  const dispatch = useAppDispatch()

  //let interval: NodeJS.Timeout

  const _interval = React.useRef(null);
  const interval = () => _interval.current;
  
  const _totalSeconds = React.useRef(null);
  const totalSeconds = () => _totalSeconds.current;

  const isFavourited = favourites.some((item: Meditation) => item.id === meditation?.id)

  const onFavourite = () => {
    dispatch(updateFavourite(meditation))
  }

  if (!meditation) {
    return <NotFoundScreen />
  }

  const { title, subtitle, image } = meditation

  const check = () => {
  }
  
  return (
    <View style={styles.container}>
      <FavouriteButton isFavourited={isFavourited} style={styles.favourite} onPress={onFavourite} />
      <Text style={styles.title}>Dream Induced Lucid Dream</Text>
      <Image source={image} style={styles.image} />
          <TouchableOpacity onPress={check} style={styles.button}>
            <Text style={styles.buttonText}>Check</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={check} style={styles.button}>
            <Text style={styles.buttonText}>Schedule</Text>
          </TouchableOpacity>
    </View>
  )
}

const screen = Dimensions.get("window");

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingLeft: 32,
    paddingRight: 32,
  },
  title: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 20,
  },
  subtitle: {
    textAlign: 'center',
    fontSize: 16,
    marginBottom: 20,
  },
  image: {
    width: '100%',
    height: '100%',
    maxWidth: 300,
    maxHeight: 300,
    marginBottom: 10,
    borderRadius: 10,
    alignSelf: 'center',
  },
  favourite: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  nav: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems:'center',
    width: 1000,
    borderBottomWidth: 2,
    flexWrap : 'wrap',
  },
  toolbar: {
    flexDirection: 'row',
    alignItems: 'center',
    width: 1000,
  },
  timerText: {
    textAlign: 'center',
    fontSize: 48
  },
  timeElapsedText: {
    textAlign: 'center',
    fontSize: 20
  },
  button: {
    borderWidth: 4,
    borderColor: "#4682B4",
    width: '90%',
    height: 120,
    borderRadius: 50,
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    marginTop: 20
  },
  buttonStop: {
    borderColor: "#FF851B"
  },
  buttonText: {
    justifyContent: "center",
    textAlign: 'center',
    fontSize: 28,
    color: "#4682B4"
  },
  buttonTextStop: {
    color: "#FF851B"
  },
})
